export const sortOptionsByRankingTotals = (options = [], totals = {}) =>
  [...options].sort((a, b) => {
    const diff =
      Number(totals?.[b?.value] || 0) - Number(totals?.[a?.value] || 0);

    if (diff !== 0) return diff;

    return String(a?.label || '').localeCompare(String(b?.label || ''));
  });

export const findOptionByValue = (options = [], value = '') =>
  options.find(option => option?.value === value) || null;
